import * as acts from './parts/acts'
import * as auth from './parts/auth'
import * as basicData from './parts/basicData'
import * as bookingAgencies from './parts/bookingAgencies'
import * as contracts from './parts/contracts'
import * as contractTemplates from './parts/contractTemplates'
import * as financialExports from './parts/financialExports'
import * as organizers from './parts/organizers'
import * as people from './parts/people'
import * as planner from './parts/planner'
import {plannerEvents} from './parts/plannerEvents'
import * as search from './parts/search'
import * as showTypes from './parts/showTypes'
import * as venues from './parts/venues'

export const api = {
  auth,
  acts,
  basicData,
  bookingAgencies,
  contracts,
  contractTemplates,
  financialExports,
  organizers,
  people,
  planner,
  plannerEvents,
  search,
  showTypes,
  venues,
}

export {
  getApiUrl,
  getApiUrlFromEntityType,
  getApiUrlFromEventType,
} from './urls'
